import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

const Loading = ({ useSecondaryColor, customStyle }) => {
  return (
    <Box
      top="0"
      left="0"
      width="100%"
      zIndex={100}
      display="flex"
      position="fixed"
      alignItems="center"
      justifyContent="center"
      bgcolor={useSecondaryColor ? 'transparent' : 'rgba(238, 238, 238, 0.5)'}
      style={customStyle}>
      <CircularProgress color={useSecondaryColor ? 'secondary' : 'primary'} />
    </Box>
  );
};

Loading.defaultProps = {
  useSecondaryColor: false,
};

Loading.propTypes = {
  customStyle: PropTypes.object,
  useSecondaryColor: PropTypes.bool,
};

export default Loading;
